import { useAuthenticatedApiClient, usePublicApiClient } from '@guiker/react-framework'
import { AuthenticatedApiClient, PublicApiClient } from '@guiker/recommended-listing-api-client'

export const useRecommendedListingPublicApiClient = usePublicApiClient(PublicApiClient)
export const useRecommendedListingAuthApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
